<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 18 18"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M7.296 10.172l-5.358 2.81A1.324 1.324 0 0 1 0 11.812V6.189a1.324 1.324 0 0 1 1.938-1.172l5.358 2.811a1.324 1.324 0 0 1 0 2.344zm4.616-5.06h.53c.73 0 1.323.592 1.323 1.323v5.13c0 .731-.593 1.324-1.324 1.324h-.53a1.324 1.324 0 0 1-1.323-1.324v-5.13c0-.731.593-1.324 1.324-1.324zm4.235 0h.53c.73 0 1.323.592 1.323 1.323v5.13c0 .731-.593 1.324-1.324 1.324h-.529a1.324 1.324 0 0 1-1.323-1.324v-5.13c0-.731.592-1.324 1.323-1.324z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
